import React from 'react';

/**
 * SyringeIcon — medizinische Outline-Spritze (Lucide „Syringe").
 *
 * Fachliche Ausnahme laut Issue #9: ausschließlich für Tollwutimpfung /
 * Impfstatus / „Geimpft". Stroke-basiert im einheitlichen Outline-Stil mit
 * vergleichbarer Strichstärke wie Heroicons. Attributsymbol und farbiger
 * Status bleiben getrennt.
 *
 * Nachgebaut aus lucide-react, um keine zusätzliche Abhängigkeit einzuführen.
 */
const SyringeIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="m18 2 4 4" />
    <path d="m17 7 3-3" />
    <path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5" />
    <path d="m9 11 4 4" />
    <path d="m5 19-3 3" />
    <path d="m14 4 6 6" />
  </svg>
);

export default SyringeIcon;
